import { Component, input } from '@angular/core';
import { RdsDividerModule, RdsIconsModule, RdsLinkModule} from '@rds/angular-components';
import { PANORAMA_OFFERING_TEXTS } from '../../../constants/panorama.constants';

@Component({
  selector: 'inexp-knowledge-learning-resources',
  imports: [RdsLinkModule, RdsIconsModule, RdsDividerModule],
  templateUrl: './knowledge-learning-resources.component.html',
  styleUrl: './knowledge-learning-resources.component.scss',
})
export class KnowledgeLearningResourcesComponent {
  _uid = input<string>();
  component = input<string>();
  learningResources = input<any[]>();
  hasPublishedItems(): boolean {
    return this.learningResources()?.some(b => b.published === true) ?? false;
  }
  readonly OFFERING_TEXT = PANORAMA_OFFERING_TEXTS;

}
